export const passwordManagerDisableAutofillProps = { 'data-1p-ignore': true } as const;
